import { EcommerceProduct } from './models/ecommerce-product.interface';
import { emitEvent } from './event-emitter';
import { GET_ECOMMERCE_ACTION, EVENT_GET_LEAD } from './constants';
import store from './store';
import {
  reviewProduct,
  addProductToCart,
  removeLastProductFromCart,
  purchaseProducts
} from './reducers/ecommerce/ecommerce.actions';

export enum EcommerceAction {
  REVIEW = 'review',
  CART = 'cart'
}

class Ecommerce {
  dispatch = store.dispatch;

  private getCart() {
    return [...store.getState().ecommerce.cart];
  }

  add(action: EcommerceAction, product: EcommerceProduct) {
    

    if (action == EcommerceAction.REVIEW) {
      this.dispatch(reviewProduct(product));
      emitEvent(GET_ECOMMERCE_ACTION, { ecommerce: { detail: { products: [product] }}});
    }

    if (action == EcommerceAction.CART) {  
      this.dispatch(addProductToCart(product));
      emitEvent(GET_ECOMMERCE_ACTION, { ecommerce: { add: { products: [product] }}});
    }
  }

  removeLast() {
    const cart = this.getCart();
    const last = cart.pop();

    if (last) {
      emitEvent(GET_ECOMMERCE_ACTION, { ecommerce: { remove: { products: [last] }}});
      this.dispatch(removeLastProductFromCart());
    }
  }

  purchase(leadId: string) {
    emitEvent(GET_ECOMMERCE_ACTION, {
      ecommerce: {
        purchase: { 
          actionField: {
            id: leadId,
            goal_id: EVENT_GET_LEAD
          },
          products: this.getCart()
        }
      }
    });

    this.dispatch(purchaseProducts());
  }
}

export const ecommerce = new Ecommerce();